import Typography from '@components/v2/ui/Typography/Typography';
import { Divider, Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface OrderConditionSectionLabelProps {
  label: LangEnum;
}

const OrderConditionSectionLabel = ({ label }: OrderConditionSectionLabelProps) => {
  const { translate } = useTranslation();

  return (
    <Stack direction="row" sx={{ alignItems: 'center', columnGap: 1 }}>
      <Typography noWrap variant="body2" sx={{ color: 'text.secondary' }}>
        {translate(label)}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Stack>
  );
};

export default OrderConditionSectionLabel;
